<a>
    <span ng-bind-html="match.model.displayName | uibTypeaheadHighlight:query"></span>
</a>


